
import ManageSettingRoute from '@/views/Setting/ManageSetting/router'

export default [
  {
    path: '',
    component: () => import(/* webpackChunkName: "settingInfo" */ '@/views/Setting/ManageSetting/Index.vue'),
    children: ManageSettingRoute
  }
]
